import {Button, Group, Modal, Text} from "@mantine/core";
import {Trans, useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {dibApi} from "../../../chat/dibApi";
import {buildCollectionUrl, type TopicMeta} from "./utils";

type DeleteFillingModalProps = {
    opened: boolean;
    onClose: () => void;
    collectionId: string;
    collectionName: string;
    topicMeta: TopicMeta;
};

export const DeleteFillingModal = ({
    opened,
    onClose,
    collectionId,
    collectionName,
    topicMeta,
}: DeleteFillingModalProps) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [deleteFilling, {isLoading}] =
        dibApi.endpoints.deleteFilling.useMutation();

    const handleDelete = () => {
        if (!collectionId || !topicMeta.topicId) return;

        deleteFilling({
            collectionId,
            topicId: topicMeta.topicId,
        })
            .unwrap()
            .then(() => {
                navigate(buildCollectionUrl(topicMeta));
                onClose();
            });
    };

    return (
        <Modal opened={opened} onClose={onClose} title={t("Action.DeleteFilling")}>
            <Text>
                <Trans
                    i18nKey="Prompt.WouldYouLikeToDeleteFilling"
                    values={{fillingTitle: collectionName}}
                    components={{"strong-1": <strong />}}
                />
            </Text>
            <Group justify="flex-end" mt="lg">
                <Button variant="subtle" disabled={isLoading} onClick={onClose}>
                    {t("common.cancel")}
                </Button>
                <Button
                    color="red"
                    loading={isLoading}
                    onClick={handleDelete}
                >
                    {t("common.delete")}
                </Button>
            </Group>
        </Modal>
    );
};
